module.exports = __webpack_public_path__ + "static/media/kingspan.46489892.png";